import Layout from '../components/Layout';
import { RegistroNovedadComponent } from '../components/RegistroNovedad';

export default function Novedades() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        {/* Encabezado */}
        <div className="bg-white shadow-sm rounded-lg px-4 py-5 sm:p-6 mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold leading-7 text-gray-900">
                Registro de Novedades
              </h1>
              <p className="mt-1 text-sm text-gray-500">
                Gestiona tus novedades laborales de manera eficiente
              </p>
            </div>
          </div>
        </div>

        {/* Contenedor principal */}
        <div className="bg-white shadow-sm rounded-lg overflow-hidden">
          <div className="p-6">
            <RegistroNovedadComponent />
          </div>
        </div>
      </div>
    </Layout>
  );
}
